let positive = ['Это правильный ответ.', 'Правильно!', 'Великолепно!', 'Отличный ответ!', 'Браво!', 'Верно!', 'Да, так и есть.', 'Блестяще!', 'Совершенно верно.', 'И это... правильный ответ!',  'Ответ верен.', 'Отличная работа.'];

module.exports = positive;